import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { DashboardBottomNav } from "@/components/dashboard/DashboardBottomNav";
import { DashboardProvider } from "@/components/dashboard/DashboardContext";
import { DashboardSidebar } from "@/components/dashboard/DashboardSidebar";
import { DashboardTopBar } from "@/components/dashboard/DashboardTopBar";
import { LoadingScreen } from "@/components/LoadingScreen";
import { useSession } from "@/hooks/auth-hooks";

export const Route = createFileRoute("/dashboard")({
	head: () => ({
		meta: [
			{ title: "Dashboard - AgentMRR" },
			{ name: "robots", content: "noindex, nofollow" },
		],
	}),
	component: DashboardLayoutRoute,
});

function DashboardLayoutRoute() {
	const navigate = useNavigate();
	const { user, isPending } = useSession();

	useEffect(() => {
		if (isPending) return;
		if (!user) {
			navigate({
				to: "/signup",
				search: { redirect: window.location.pathname },
				replace: true,
			});
		}
	}, [user, isPending, navigate]);

	if (isPending || !user) {
		return <LoadingScreen />;
	}

	return (
		<DashboardProvider>
			<div className="relative min-h-svh bg-background">
				<DashboardSidebar />
				<div className="lg:pl-56">
					<DashboardTopBar />
					<Outlet />
				</div>
				<DashboardBottomNav />
			</div>
		</DashboardProvider>
	);
}
